import React, {useState, useEffect} from "react";
import LoadingBar from "react-top-loading-bar";

const BarLoader = () => {
    const [loaderTimer, setLoaderTimer] = useState(10);

    useEffect(() => {
        let initialValue = 10;
        setInterval(() => {
            if (initialValue !== 100) {
                setLoaderTimer(initialValue += 10)
            }
        }, 100);

    }, []);

    return <LoadingBar
        progress={loaderTimer}
        height={3}
        color='#2b3e50'
    />

};

export default BarLoader;
